import { LABELS } from "~/resources/Labels";
import { TableHeaderType } from "../types/TableHeaderType";

export const ScriptsHeader: TableHeaderType[] = [
    {
      label: LABELS.DeploymentScriptIDTitle,
      key: 'scriptIdentify',
      id: 'scriptIdentify.deploymentScriptId',
      sortable: false,
    },
    {
      label: LABELS.CloudProviderWithSpace,
      key: "cloudEnvironment",
      id: 'cloudEnvironment.cloudProvider.cloudProviderName',
      sortable: true,
    },
    {
      label: LABELS.CloudEnviroment,
      key: "cloudEnvironment",
      id: 'cloudEnvironment.environmentName',
      sortable: true,
    },
    {
      label: LABELS.Title,
      key: 'title',
      id: 'title',
      sortable: true,
    },
    {
      id: 'creationDate',
      label: LABELS.DateAdded,
      alignment: '',
      sortable: true,
      key: 'creationDate',
    },

    {
      id: 'actions',
      label:'',
      alignment: '',
      sortable: false,
      key: '',
    },
  ];
